import * as React from 'react';
import { connect } from 'react-redux';

import Header from './Header';
import HeaderButtons from './HeaderButtons';
import ReportSettingsForm from '../reportSettings/FormContainer';

import {
    ReportTemplate as ReportTemplateActions,
    SaveState as SaveStateActions,
    Modal as ModalAction,
} from '../../actions';
import { ReportSetting as ReportSettingActions } from '../../actions';

import IState from '../../interfaces/states';
import IReportSettings from '../../interfaces/IReportSettings';
import { Customer, ReportTemplate } from '../../store/models';

interface IProps {
    isDirty: boolean,
    isSaved: boolean,
    isSaving: boolean,
    reportTemplate: ReportTemplate,
    reportSettings: IReportSettings,
    save: Function,
    openModal: Function,
}

function onSave(evt: Event, props: IProps) {
    props.save('header', props.reportTemplate);
}

function onOpen(evt: Event, props: IProps) {
    props.openModal('open');
}

const HeaderContainer: React.StatelessComponent<IProps> = (props: IProps) => {
    return (
        <Header>
            <HeaderButtons
                key="buttons"
                {...props}
                onSave={(evt) => onSave(evt, props)}
                onOpen={(evt) => onOpen(evt, props)} />

            <ReportSettingsForm 
                className="navbar-form"
            />
        </Header>
    );
}

HeaderContainer.propTypes = {
    isDirty: React.PropTypes.bool,
    isSave: React.PropTypes.bool,
    isSaving: React.PropTypes.bool,
    reportTemplate: React.PropTypes.object.isRequired,
    reportSettings: React.PropTypes.object.isRequired,
    save: React.PropTypes.func.isRequired,
    openModal: React.PropTypes.func.isRequired,
};

const mapStateToProps = (state: IState) => {
    return {
        isDirty: state.saveState.dirty,
        isSaved: state.saveState.saved,
        isSaving: state.saveState.saveRequest,
        reportTemplate: state.reportTemplate as ReportTemplate,
        reportSettings: state.reportSettings,
    }
};

export default connect(
    mapStateToProps,
    {
        save: ReportTemplateActions.save,
        openModal: ModalAction.open,
    }
)(HeaderContainer);



// WEBPACK FOOTER //
// ./src/components/header/HeaderContainer.tsx